// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__Otl-W","active":"Burger_active__Elcoj"};